import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { routes } from './routes';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (status === 'signedOut') {
    const nextParam = location.pathname !== routes.HOME 
      ? `?next=${encodeURIComponent(location.pathname)}` 
      : '';
    return <Navigate to={`${routes.SIGNIN}${nextParam}`} replace />;
  }

  return <>{children}</>;
}